module.exports = __webpack_public_path__ + "img/i_ios.89b51766.svg";